import { useQuery } from "@tanstack/react-query";
import { api } from "@/services/api";

export const DESK_PROFILE_KEY = ["desk-profile", "me"] as const;

/** The caller's Desk profile status: whether setup is required before the dashboard (KC-507). */
export function useDeskProfile() {
  return useQuery({ queryKey: DESK_PROFILE_KEY, queryFn: () => api.getDeskProfile() });
}
